import firstLandingPage from '@/components/landing-pages/index1/index1.vue';
import secondLandingPage from '@/components/landing-pages/index2/index2.vue';

export default [
  {
    path: '/index1',
    name: 'index1',
    component: firstLandingPage,
    meta: {
      requiresAnonymous: true,
    },
  },
  {
    path: '/index2',
    name: 'index2',
    component: secondLandingPage,
    meta: {
      requiresAnonymous: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/static.js